
import './App.css';
import Navbar from './Components/Pages/Navbar';
import Body from './Components/Pages/Body';
function App() {
  return (
    <div className="App">
      <Navbar/>
      <Body/>
    </div>
  );
}

export default App;
